<template>
  <div class="mit-home-page mit-page">

      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Home</v-card-title>
            <v-card-subtitle class="caption">CSAIL buildings and spaces</v-card-subtitle>
            <v-divider></v-divider>

            <v-card-text>
              Home page
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

  export default {
    name: 'MitHomePage',
    components: {
    },
    data: function() {
      return {
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
